import React, { useState, useEffect } from 'react';

import { FieldProps } from 'formik';
import DatePicker, { registerLocale } from 'react-datepicker';
import { FormFeedback, FormGroup, Label } from 'reactstrap';
import { Calendar } from 'lucide-react';
import { es } from 'date-fns/locale';
import dayjs from 'dayjs';

registerLocale('es', es as any);

interface Props {
   name: string;
   label?: string;
   placeholder?: string;
   className?: string;
   required?: boolean;
   minDate?: Date;
   style?: React.CSSProperties;
   showMonthYearPicker?: boolean;
}

export const CustomDatePiker: React.FC<Props & FieldProps> = ({
   field,
   form,
   name,
   label,
   placeholder = 'Seleccionar fecha...',
   className = '',
   required = false,
   minDate,
   style,
   showMonthYearPicker = false,
}) => {
   const isInvalid = !!(
      form.touched?.[field.name] && form.errors?.[field.name]
   );

   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
   useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth < 768);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
   }, []);

   const handleChange = (date: Date | null) => {
      form.setFieldValue(field.name, date);
   };

   return (
      <FormGroup>
         <Label
            for={name}
            style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
         >
            {label}
            {required && <a> *</a>}
         </Label>
         {isMobile ? (
            <div className="position-relative w-100">
               <input
                  type={showMonthYearPicker ? "month" : "date"}
                  id={name}
                  name={name}
                  className={`form-control ${className} ${isInvalid ? 'is-invalid' : ''}`}
                  required={required}
                  value={field.value ? (showMonthYearPicker ? dayjs(field.value).format('YYYY-MM') : dayjs(field.value).format('YYYY-MM-DD')) : ''}
                  onChange={(e) => {
                     const val = e.target.value;
                     if (val) {
                        form.setFieldValue(field.name, showMonthYearPicker ? dayjs(val).startOf('month').toDate() : dayjs(val).startOf('day').toDate());
                     } else {
                        form.setFieldValue(field.name, null);
                     }
                  }}
                  min={minDate ? (showMonthYearPicker ? dayjs(minDate).format('YYYY-MM') : dayjs(minDate).format('YYYY-MM-DD')) : undefined}
                  style={{
                     height: '45px',
                     width: '100%',
                     ...style
                  }}
               />
            </div>
         ) : (
            <div className="position-relative">
               <DatePicker
                  id={name}
                  name={name}
                  className={`${className} ${isInvalid ? 'is-invalid' : ''}`}
                  selected={field.value}
                  onChange={handleChange}
                  placeholderText={placeholder}
                  showIcon={false}
                  required={required}
                  minDate={minDate}
                  locale="es"
                  showMonthYearPicker={showMonthYearPicker}
                  dateFormat={showMonthYearPicker ? "MM/yyyy" : "dd/MM/yyyy"}
                  customInput={
                     <input
                        style={{
                           paddingLeft: '38px',
                           height: '45px',
                           ...style
                        }}
                     />
                  }
               />
               <Calendar size={18} className="position-absolute text-muted" style={{ left: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
            </div>
         )}
         {isInvalid && (
            <FormFeedback className="d-block">
               {(form.errors?.[field.name] as string) || 'Error inesperado'}
            </FormFeedback>
         )}
      </FormGroup>
   );
};
